<h3>Suppliers</h3>
<div style="width: 100%;">Enter at least 3 characters in order to filter.</div>
@if (validationMessage) {
  <div class="alert alert-warning" role="alert" style="margin-top: 10px; margin-bottom: 10px;">
    {{ validationMessage }}
  </div>
}
@if (error && errorMessage) {
  <div class="alert alert-danger alert-dismissible fade show" role="alert" style="margin-top: 10px; margin-bottom: 10px;">
    {{ errorMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissError()"></button>
  </div>
}
<div style="width: 100%;">
  <kendo-grid
    [data]="view | async"
    [loading]="suppliersService.loading"
    [pageable]="pageableSettings"
    [pageSize]="state.take"
    [skip]="state.skip"
    [filterable]="'row'"
    [resizable]="true"
    [filter]="filter"
    (filterChange)="filterChange($event)"
    (pageChange)="pageChange($event)">
    <ng-template kendoGridToolbarTemplate position="top">
      <div class="d-flex justify-content-end w-100">
        <button class="btn btn-outline-secondary btn-sm" (click)="refreshData()" title="Refresh">
          <i class="fa fa-rotate-right" aria-hidden="true"></i> Refresh
        </button>
      </div>
    </ng-template>
    <ng-template kendoGridLoadingTemplate>
      <div class="d-flex justify-content-center align-items-center" style="height: 100%;">
        <div class="spinner-border alfalaval-blue-color" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </ng-template>

    <kendo-grid-column field="supplierId" title="Supplier Id" [width]="110" [minResizableWidth]="110" [resizable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="itemId" title="Item Id" [width]="110" [minResizableWidth]="110" [resizable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="itemDescription" title="Item description" [width]="170" [minResizableWidth]="170">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="itemDetailedDescription" title="Item detailed description" [width]="190" [minResizableWidth]="190">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="itemState" title="Item state" [width]="80" [minResizableWidth]="80" [resizable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ getItemStateText(dataItem.itemState) }}
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-filterService="filterService">
        <select
          class="form-select form-select-sm"
          [ngModel]="getFilterValue(filter, column.field)"
          (ngModelChange)="onItemStateFilterChange($event, filterService, filter, column.field)">
          <option value="">All</option>
          <option *ngFor="let option of itemStateOptions" [value]="option.value">{{ option.text }}</option>
        </select>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="supplierItemIdentification" title="Supplier item id" [width]="110" [minResizableWidth]="110" [resizable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="countryOfOriginCode" title="Country code" [width]="100" [minResizableWidth]="100" [resizable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="stockCode" title="Stock code" [width]="80" [minResizableWidth]="80" [resizable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="isMainSupplier" title="Main supplier" [width]="90" [minResizableWidth]="90" [resizable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.isMainSupplier ? 'YES' : 'NO' }}
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-filterService="filterService">
        <select
          class="form-select form-select-sm"
          [ngModel]="getFilterValue(filter, column.field)"
          (ngModelChange)="onBooleanFilterChange($event, filterService, filter, column.field)">
          <option value="">All</option>
          <option *ngFor="let option of booleanOptions" [value]="option.value">{{ option.text }}</option>
        </select>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="lastModificationDateTime" title="Last modification date" [filterable]="false" [width]="150" [minResizableWidth]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.lastModificationDateTime | date:'yyyy-MM-dd HH:mm:ss' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Actions" [filterable]="false" [width]="75" [minResizableWidth]="75" [resizable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button class="btn btn-outline-secondary btn-sm" (click)="viewItem(dataItem)" title="View item">
          <i class="fa fa-magnifying-glass" aria-hidden="true"></i>
        </button>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
